import script from "./cart-component.vue?vue&type=script&setup=true&lang=js"
export * from "./cart-component.vue?vue&type=script&setup=true&lang=js"

import "./cart-component.vue?vue&type=style&index=0&id=786eff3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-786eff3e"]])

export default __exports__